import clsx from 'clsx';
import { IoIosEye } from 'react-icons/io';

function StoryViews({ story, additionalClassName }) {
  return (
    <div
      className={clsx(
        'flex flex-row items-center space-x-2 text-gray-400',
        additionalClassName
      )}
    >
      <IoIosEye className="h-6 w-6" />
      <span className="">{story.get('totalViews')}</span>
    </div>
  );
}

export default StoryViews;
